// Service page content for Admissions (education placement service, not a visa).
// COMPLIANCE: education placement is genuinely our lane; keep it confident. The
// visa itself is a registered migration agent's, so decouple admission from us
// "doing the visa". No guaranteed admission or visa outcome; honest, overview level.

const admissions = {
  groupSlug: "student-graduate",
  slug: "admissions",
  title: "Admissions",
  eyebrow: "Student & Graduate",
  intro:
    "Choosing the right course and provider is the foundation of a successful student journey, and it shapes your visa application too. Our admissions support helps you find and apply to CRICOS-registered courses that genuinely fit your goals, budget, and background.",

  chips: [
    { label: "What it is", value: "Course and provider placement" },
    { label: "Providers", value: "CRICOS-registered institutions" },
    { label: "Pairs with", value: "Your student visa" },
    { label: "Decision by", value: "The institution" },
  ],

  whoFor: [
    "Prospective international students choosing where and what to study.",
    "Students who want a course that supports a genuine study plan and visa.",
    "People who want their admission handled by us and a smooth hand-off to a registered migration agent for the visa.",
  ],

  essentials: [
    {
      title: "A genuine course fit",
      detail:
        "We help you choose a course that fits your background and goals, which also supports your Genuine Student case.",
    },
    {
      title: "CRICOS-registered providers",
      detail:
        "Student visas require a registered (CRICOS) course, so we work only with eligible providers.",
    },
    {
      title: "Entry requirements",
      detail:
        "Each course has its own academic and English entry requirements. We help you meet and evidence them.",
    },
    {
      title: "Confirmation of Enrolment",
      detail:
        "A successful application leads to a Confirmation of Enrolment, which you need for the student visa.",
    },
    {
      title: "Cost and study planning",
      detail:
        "We help you understand fees and plan a study path that is realistic for your budget.",
    },
    {
      title: "Aligned with your visa",
      detail:
        "We coordinate your admission with the registered migration agent handling your visa so the two support each other.",
    },
  ],

  process: [
    {
      title: "Understand your goals",
      detail:
        "We talk through your background, budget, and where you want study to lead.",
    },
    {
      title: "Shortlist courses and providers",
      detail:
        "We match you to suitable CRICOS-registered courses and institutions.",
    },
    {
      title: "Prepare your application",
      detail:
        "We help you meet entry requirements and assemble a strong application.",
    },
    {
      title: "Secure your enrolment",
      detail:
        "Once accepted, we help you finalise your Confirmation of Enrolment.",
    },
    {
      title: "Move into your visa",
      detail:
        "We prepare and organise your student visa documents and hand straight over to a registered migration agent, who gives the migration advice and lodges.",
    },
  ],

  faqs: [
    {
      q: "Can you guarantee I get into a course?",
      a: "No. Admission decisions are made by the institution against its own entry requirements. What we do is match you to suitable courses, help you meet the requirements, and present a strong application.",
    },
    {
      q: "Do you only work with certain universities?",
      a: "We work with CRICOS-registered providers, since those are the courses eligible for a student visa. We focus on finding the right fit for you rather than pushing one provider.",
    },
    {
      q: "How does admission affect my visa?",
      a: "Your course choice feeds directly into your student visa, including the Genuine Student assessment. A course that genuinely fits your goals strengthens both. That is why we handle your admission and then hand straight over to a registered migration agent for the visa, so the two stay aligned.",
    },
    {
      q: "What does admissions support cost?",
      a: "We explain any fees clearly and in writing before you commit, and we keep them separate from government visa charges. There are no surprises.",
    },
  ],

  related: ["student-500", "oshc", "graduate-485"],

  lastVerified: "13 July 2026",
};

export default admissions;
